// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"680":"090d361b","865":"23575bf5"}[chunkId] + ".css";
};